import { MouseEvent, useState } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { Button, Checkbox } from '@zep/ui';
import { getChannelTalkSupportArticleUrl } from '@zep/utils';
import { BusinessPayment } from '../../../../types/PaymentTypes';
import { fCurrency } from '../../../../utils';
import S from '../BusinessPayments.module.scss';
import PaymentInformation from './PaymentInformation';
export const BusinessPaymentsInfo = ({
  businessName,
  businessPayment,
  onSubmit,
  productName
}: BusinessPaymentsInfoProps) => {
  const {
    locale = 'ko'
  } = useRouter();
  const {
    t
  } = useTranslation(['business', 'manage']);
  const [[isPayAgreed, isTermsAgreed], setAgreed] = useState([false, false]);
  const handleAgree = (type: 'isPayAgreed' | 'isTermsAgreed') => {
    if (type === 'isPayAgreed') {
      setAgreed(prevState => [!prevState[0], prevState[1]]);
      return;
    }
    setAgreed(prevState => [prevState[0], !prevState[1]]);
    return;
  };
  const openTermsWindow = (event: MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    if ((event.target as HTMLElement).nodeName !== 'A') {
      return;
    }
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const windowWidth = 500;
    const windowHeight = 900;
    const left = (screenWidth - windowWidth) / 2;
    const top = (screenHeight - windowHeight - 100) / 2;
    window.open(getChannelTalkSupportArticleUrl(locale, 'b40ac18f'), '_blank', `width=${windowWidth},height=${windowHeight},left=${left},top=${top}`);
  };
  return <>
      <PaymentInformation businessName={businessName} content={businessPayment.productDetail} productName={productName} price={businessPayment.priceBeforeVat ?? businessPayment.price} currency={businessPayment.currency} vatAmount={businessPayment.vatAmount} data-sentry-element="PaymentInformation" data-sentry-source-file="BusinessPaymentsInfo.tsx" />
      <div className={S.payments_final}>
        <div>
          {t('manage:donate_final_payment')}{' '}
          <b>
            {/* 최종 결제 금액은 서버 snapshot finalPrice. 서버 합류 전(필드 부재)에는
                기존 price를 표시하되, 결제 자체는 PayBusinessPayment에서 차단된다. */}
            {fCurrency(businessPayment.finalPrice ?? businessPayment.price, businessPayment.currency, {
            position: 'pre',
            currencyString: '₩'
          })}
          </b>
        </div>

        <Checkbox circle checked={isPayAgreed} label={t('manage:donate_payment_check_amount')} onChange={() => handleAgree('isPayAgreed')} data-sentry-element="Checkbox" data-sentry-source-file="BusinessPaymentsInfo.tsx" />
        <Checkbox circle checked={isTermsAgreed} onChange={() => handleAgree('isTermsAgreed')} label={<div className={S.with_terms} onClick={openTermsWindow} dangerouslySetInnerHTML={{
        __html: t('business:businessPage.payment.termsAgreement')
      }}></div>} data-sentry-element="Checkbox" data-sentry-source-file="BusinessPaymentsInfo.tsx" />
      </div>
      <Button size="lg" disabled={!isPayAgreed || !isTermsAgreed} onClick={onSubmit} data-sentry-element="Button" data-sentry-source-file="BusinessPaymentsInfo.tsx">
        {t('manage:donate_payment_creditcard')}
        &nbsp;
        {t('manage:donate_payment_pay')}
      </Button>
    </>;
};
export type BusinessPaymentsInfoProps = {
  businessName: string;
  paymentHashId: string;
  businessPayment: BusinessPayment;
  onSubmit: () => void;
  productName: string;
};